/**
 * Created by 丸子 on 2018/7/21 0021.
 */
import Router from 'vue-router'
import Vue from 'vue'

const index = () => import('./page/index')

Vue.use(Router)

const routes= [
  {
    path: '/',
    redirect: '/index',
    meta: {
      name: 'NFT英雄',
      requireLogin:true
    }
  },
  {
    path: '/index',
    component:index,
    meta: {
      name: 'NFT英雄',
      requireLogin:true
    }
  }
]

const router = new Router({
  base: '/', // 配置单页应用的基路径
  routes
})

export default router
